import React, { useState } from "react";

function InputNombrePuertoSw({
    value,
    setValue,
    label = "Nombre del puerto switch",
    placeholder = "sw1_ep_p1_10",
    title = "Máximo 12 caracteres",
    readOnly = false
}) {
    const [error, setError] = useState("");

    const reglas = [
        /^[s]$/,        // 1
        /^[w]$/,        // 2
        /^[1-9]$/,      // 3
        /^[_]$/,        // 4
        /^[a-p]$/,      // 5
        /^[a-p]$/,      // 6
        /^[_]$/,        // 7
        /^[a-z]$/,      // 8
        /^[a-z0-9]$/,   // 9
        /^[_]$/,        // 10
        /^[1-9]$/,      // 11
        /^[0-9]$/       // 12
    ];

    const handleChange = (e) => {
        let inputValue = e.target.value.toLowerCase();

        // Solo permitir hasta 12 caracteres
        if (inputValue.length > 12) return;

        // Validar cada carácter según su posición
        for (let i = 0; i < inputValue.length; i++) {
            const char = inputValue[i];
            if (!reglas[i].test(char)) {
                setError(`Carácter inválido en posición ${i + 1}`);
                return;
            }
        }

        setError(""); // Si todo está bien, limpia el error
        setValue(inputValue);
    };

    return (
        <div className="form-group">
            <label>{label}</label>
            <input
                className={`input ${error ? "input-error" : ""}`}
                type="text"
                maxLength={12}
                value={value}
                onChange={handleChange}
                placeholder={placeholder}
                title={title}
                readOnly={readOnly}
            />
            {error && <small className="error-text">{error}</small>}
        </div>
    );
}

export default InputNombrePuertoSw;